import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { IActivity } from "@comunicare/comunicare-interfaces";
import * as moment from "moment";
import { BehaviorSubject } from "rxjs";

export class ActivityListDataSource extends MatTableDataSourceExtended<IActivity> {
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  sortingDataAccessor = (data: IActivity, sortHeaderId: string) => {
    switch (sortHeaderId) {
      case "name":
        return data.reference.display;
      case "startDate":
        return moment(data.detail.scheduledString).unix();
      case "endDate":
        return moment(data.detail.scheduledString).unix();
      case "responsable":
        return this.getActivityPerformerDisplay(data);
      case "status":
        return data.detail.status;
      default:
        return "";
    }
  };

  constructor() {
    super();
  }

  public loadData(activeActivity: IActivity[]) {
    this.data = activeActivity;
  }

  public getActivityPerformerDisplay(activity: IActivity): string | null {
    if (activity?.detail?.performer && activity.detail.performer.length) {
      return activity.detail.performer[0].display;
    }
    return null;
  }
}
